import { render } from "./AdminPackageList.vue?vue&type=template&id=4ace2e7d&ts=true&lang=true"
import script from "./AdminPackageList.vue?vue&type=script&lang=ts"
export * from "./AdminPackageList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__